// Pure mapping of a payment attempt's server status to what the Pay-now dialog
// shows. Four distinct states — never collapse "we don't know yet" into either
// "paid" or "failed" (rule: no data is not good news; money: unknown ≠ failed).
export type PayView =
  | { kind: 'waiting' } // prompt is on the payer's phone / bank is processing
  | { kind: 'confirming' } // outcome unknown — being confirmed; payer must NOT pay again
  | { kind: 'failed'; reason: string | null } // definitively not charged — may retry
  | { kind: 'paid' };

export function payAttemptView(status: string | undefined | null, reason?: string | null): PayView {
  switch ((status || '').toLowerCase()) {
    case 'success':
      return { kind: 'paid' };
    case 'failed':
    case 'cancelled':
    case 'expired':
      return { kind: 'failed', reason: reason || null };
    case 'unknown':
      return { kind: 'confirming' };
    case 'initiated':
    case 'pending':
      return { kind: 'waiting' };
    default:
      // An unreadable / missing status is NOT good news and NOT a failure.
      return { kind: 'confirming' };
  }
}

/** Sandbox test MSISDNs (0000000000NN) are accepted only in M-Pesa sandbox mode. */
export const isSandboxTestNumber = (v: string) => /^0{10}\d{2}$/.test(v.replace(/\D/g, ''));
